// I wouldn't usually create a custom.js file, 
// but the Superstore.js file is obnoxiously huge. (29k lines)


function centerContentResizer(arr) {
    var container = $(arr.par)[0],
        content = $(arr.chld)[0],
        hght = arr.hght,
        type = arr.type;
    initCheck();
    $(window).resize(function() {
        initCheck();
    });

    function initCheck() {
        if (typeof hght === 'undefined') { hght = 120; }
        if (typeof type === 'undefined') { type = 'min-height'; }
        $containerHeight = $(container).outerHeight();
        $contentHeight = $(content).outerHeight() + hght;
        if ($containerHeight < $contentHeight) {
            $(container).css(type, $contentHeight);
        }

    }
}




$(document).ready(function() {


    $('.live-search-button').on('click touch', function() {
        $(this).closest('.live-search').toggleClass('.live-search--focused').find(':focusable').first().focus();
    })


    // Accordian
    var animTime = 500,
        clickPolice = false;
    $(document).on('touchstart click', '.acc-btn', function() {
        if (!clickPolice) {
            clickPolice = true;
            var currIndex = $(this).index('.acc-btn'),
                targetHeight = $('.acc-content-inner').eq(currIndex).outerHeight();
            var expanded = $(this).find('h3').hasClass('selected');
            if (expanded) {
                $('.acc-btn h3').removeClass('selected');
                $('.acc-btn .img').removeClass('selected');
                $('.acc-content').eq(currIndex).stop().animate({ height: targetHeight }, animTime);
                $('.acc-content').stop().animate({ height: 0 }, animTime);
            } else {
                winWidth = $(window).width();
                $('.acc-btn h3').removeClass('selected');
                $('.acc-btn .img').removeClass('selected');
                $(this).find('h3').addClass('selected');
                $(this).find('.img').addClass('selected');
                $('.acc-content').stop().animate({ height: 0 }, animTime);
                $('.acc-content').eq(currIndex).stop().animate({ height: targetHeight }, animTime);
                if (winWidth < 767) { // May have finally gotten this right
                    setTimeout(function() {
                        // optional to clear sticky headers
                        clearItem = $('.site-header');
                        // if (clearItem.is('.site-header--sticky')) {
                        //   clear = clearItem.outerHeight(true) + 15;
                        // } else {
                        // }
                        clear = clearItem.outerHeight(true) * 1.25;


                        openTabReset = $('h3.selected');
                        openTabDist = openTabReset[0].getBoundingClientRect().top + window.scrollY - clear;
                        console.log(openTabDist)
                        $([document.documentElement, document.body]).animate({
                            scrollTop: openTabDist
                        }, animTime);
                    }, animTime * 2.5);
                }
            }
            setTimeout(function() { clickPolice = false; }, animTime);
        }
    });

})



let customerSelection = []

$(document).ready(function() {

    // Preloads customer selection based on page default
    let initialOptionOne = $('.v-opt.hover') ? $('.v-opt.hover').find('.v-title').text() : $('.v-opt.hover').find('.v-title').text();

    let initialOptionTwo = $('#product-select-option-2 > option:selected').attr('value') ? $.trim($('#product-select-option-2 > option:selected').attr('value')) : '';


    customerSelection = [initialOptionOne, initialOptionTwo];

    let fillChoice = `${customerSelection[0]} / ${customerSelection[1]}`

    $('.v-opt').click(function() {
        // alert('Click inside of product load');
        customerSelection[0] = $(this).text().trim();
    });

    // $('#product-select-option-2').change(function () {
    //   customerSelection[1] = $.trim($('#product-select-option-2 > option:selected').attr('value'));
    // });

    // Allows hidden menu to select customer choice and therefore take this selection through to checkout.  This function also updates the url query string with the correct variant number based on the customer's chosen combination. 
    $('.v-opt').on('click', doSomething);

    // $('.v-opt').on('click', function(event) {
    //   if ($(this).hasClass('main-view-img')) {
    //     let colorSelectorIndex = $(this).index();
    //     console.log(colorSelectorIndex)
    //     // $(this).closest('.grid__item').find('.background-image').removeClass('show').addClass('hide');
    //     // $(this).closest('.grid__item').find('.background-image').eq(colorSelectorIndex).removeClass('hide').addClass('show');
    //   } else {
    //     location.hash = $(this).attr('href');
    //   }
    // });

    function doSomething(e) {
        e.preventDefault();

        let allOptions = $('option');
        let allSelectables = $('[data-variants]').find(allOptions);

        allSelectables.each(function() {
            customerSelection[1] === '' ? fillChoice = customerSelection[0] : fillChoice = `${customerSelection[0]} / ${customerSelection[1]}`
            console.log('new fillChoice:', fillChoice)
            // console.log($.trim($(this).text()))
            // console.log($.trim($(this).text()).toLowerCase().indexOf(fillChoice.toLowerCase()) != -1)


            
            if ( $.trim($(this).text()).toLowerCase().indexOf(fillChoice.toLowerCase()) != -1 ) {
                $('#product-combination').text(fillChoice)
                $(this).attr("selected", "selected");

                let url = "?variant=" + $(this).val();
                window.history.pushState("data", "Title", url);
                document.title = fillChoice;

            } else {
                $(this).removeAttr('selected');
            }
        })
    }

    // if select input
    // Changes customer quantity choice within Add to Cart Sticky (mobile)
    $('#product-quantity-select').on('change', function() {

        let enteredQty = $(this).data('oldVal', $(this)).val();
        let lastQtyChosen = $('#displayQty').text();
        let displayQty = `, Qty ${enteredQty}`

        if (!enteredQty) {
            $('#displayQty').text(lastQtyChosen);
        } else if ($(this).data('oldVal') !== $(this).val()) {
            $(this).data('newVal', $(this).val());
            $('#displayQty').text(displayQty);
        }
    })

    // if text input
    // Changes customer quantity choice within Add to Cart Sticky (mobile)
    $('#product-quantity-input').on('keyup', function() {

        let enteredQty = $(this).data('oldVal', $(this)).val();
        let lastQtyChosen = $('#displayQty').text();
        let displayQty = `, Qty ${enteredQty}`

        if (!enteredQty) {
            $('#displayQty').text(lastQtyChosen);
        } else if ($(this).data('oldVal') !== $(this).val()) {
            $(this).data('newVal', $(this).val());
            $('#displayQty').text(displayQty);
        }
    })

    // // Updates subscribe and deliver text based upon customer selection.
    // console.log($('.bold-ro__recurring-lbl input:radio').val());
    // $('.bold-ro__frequency-num').remove();
    // $('select.bold-ro__frequency-num').change( function() {
    //   console.log($(this));
    // })


  function checkSubInCart(next){
    $.getJSON('/cart.js', function(data){
      var hasSub = false;
      data.items.forEach(function(item){
        if(typeof item.properties.frequency_num != "undefined"){
          hasSub = true;
        }
      });
      next(hasSub);
    });
  }

  $(document).ajaxComplete(function(){
    checkSubInCart(function(hasSub){
      if(hasSub){
        $('[data-atc-button-checkout]').remove();
      }
    })
  })


});








window.addEventListener('load', (event) => {
  $('.cart-title-button').removeAttr('disabled');
});




































// MUST BE LAST IN FILE
var themeJSisLoaded = true;